import {isNil} from 'ramda';

import type {Nullish} from 'shared/web';

/**
 * The newer of an editor's own record and its row in a list, so the image an editor shows and the
 * version it comes with are from the same read. At one version the row wins: a refetch of the list
 * after an expired image URL brings its new URL.
 */
export const newerRecord = <T extends {id: string; version: number}>(
  record: T,
  rows: T[] | Nullish
) => {
  const row = rows?.find(({id}) => id === record.id);
  return !isNil(row) && row.version >= record.version ? row : record;
};
